import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ConfiguratorUriParameterService {
  constructor(private activatedRoute: ActivatedRoute) {}

  getQueryParam(param: string): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get(param);
  }

  getAccount(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('account');
  }

  getAction(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('action');
  }

  getContact(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('contact');
  }

  getContract(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('contract');
  }

  getContractItemNumber(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('contractItemNumber');
  }

  getItemId(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('itemId');
  }

  getProduct(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('product');
  }

  getProductName(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('productName');
  }

  getSourceProduct(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('sProduct');
  }

  getSourceProductName(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('sProductName');
  }

  getDerivativeProductsFromUrl(): string {
    const derivativeProducts = this.activatedRoute.snapshot.queryParamMap.get('derivativeProducts');
    if (derivativeProducts) {
      return decodeURIComponent(derivativeProducts);
    }
    return '';
  }

  getErrorCode(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('errorCode');
  }

  getResetParam(): string | null {
    return this.activatedRoute.snapshot.queryParamMap.get('reset');
  }
}
